// LogoutButton.jsx

import React, { useState } from 'react';

// Context
import { useTheme } from 'context/ThemeContext';

// CSS
import './LogoutButton.css';

/**
 * LogoutButton
 * 
 * Renders a button that allows the user to log out.
 * 
 * @param {function} onClick - The function to call when the button is clicked.
 *  
 * @returns {ReactNode} - LogoutButton.
 */
const LogoutButton = React.memo(({ onClick }) => {

    // ----- CONTEXT ----- //

    // Theme Context
    const { theme } = useTheme();

    // ----- STATE ----- //

    // Hover State
    const [hovered, setHovered] = useState(false);

    // ----- RENDER ----- //

    return (

        <div className="logout-button-container"
            style={{
                backgroundColor: hovered ? theme.buttonHoverBackgroundColor : 'transparent',
                color: hovered ? theme.buttonHoverLabelColor : theme.foregroundMuted,
            }}
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}>
            Sign Out
        </div>
    );

});

// Dev Tools
LogoutButton.displayName = 'LogoutButton';

export default LogoutButton;

